import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-google-image',
  templateUrl: './google-image.component.html',
  styleUrls: ['./google-image.component.scss']
})
export class GoogleImageComponent {
  constructor(private dialogRef: MatDialogRef<GoogleImageComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
